import { Footer } from '../homepage/Footer';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SecurityMessages as msg } from './SecurityPage.messages';
import { PageSeo } from '../seo/PageSeo';
import { breadcrumbSchema } from '../seo/schemas';
import './static-page.css';

export const SecurityPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
    <PageSeo
      path="/security"
      titleKey="seo.security.title"
      descriptionKey="seo.security.description"
      ogImage="/og/og-default.png"
      jsonLd={[breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Security', path: '/security' }])]}
    />
    <div className="page-wrapper"><div className="static-page">
      <h1>{t(msg.PAGE_TITLE)}</h1>
      <p className="page-subtitle">{t(msg.PAGE_SUBTITLE)}</p>

      <h2>{t(msg.INFRASTRUCTURE_TITLE)}</h2>
      <ul>
        <li>{t(msg.INFRA_ITEM_1)}</li>
        <li>{t(msg.INFRA_ITEM_2)}</li>
        <li>{t(msg.INFRA_ITEM_3)}</li>
        <li>{t(msg.INFRA_ITEM_4)}</li>
      </ul>

      <h2>{t(msg.AUTHENTICATION_TITLE)}</h2>
      <ul>
        <li>{t(msg.AUTH_ITEM_1)}</li>
        <li>{t(msg.AUTH_ITEM_2)}</li>
        <li>{t(msg.AUTH_ITEM_3)}</li>
      </ul>

      <h2>{t(msg.DATA_HANDLING_TITLE)}</h2>
      <ul>
        <li>{t(msg.DATA_ITEM_1)}</li>
        <li>{t(msg.DATA_ITEM_2)}</li>
        <li>{t(msg.DATA_ITEM_3)}</li>
        <li>{t(msg.DATA_ITEM_4)}</li>
      </ul>

      <h2>{t(msg.ACCESS_CONTROL_TITLE)}</h2>
      <ul>
        <li>{t(msg.ACCESS_ITEM_1)}</li>
        <li>{t(msg.ACCESS_ITEM_2)}</li>
        <li>{t(msg.ACCESS_ITEM_3)}</li>
      </ul>

      <h2>{t(msg.REPORTING_TITLE)}</h2>
      <p dangerouslySetInnerHTML={{ __html: t(msg.REPORTING_DESC) }} />
    </div>
    <Footer />
    </div>
    </>
  );
};
